import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-2_3wWCHkQNa", 
  ClientId: "sidesaekl5ld23f09bdsr49e5"
};

export const userPool = new CognitoUserPool(poolData);